const initialState = {
  companyList: { data: [] },
};

export const company_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_COMPANY_LIST":
      return {
        ...state,
        companyList: action.payload,
      };
    case "DELETE_COMPANY":
      return {
        ...state,
        companyList: { ...state.companyList, data: state.companyList.data.filter((li) => li.id !== action.payload) },
      };
    default:
      return state;
  }
};
